// extracted by mini-css-extract-plugin
export var truncate = "_m-0";